import axios from 'axios';
import API_URL from '../config/config';

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add Authorization Token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
        if (!config.headers) config.headers = {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;
